"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRuleEdit_1 = require("./../initializeInboxRuleEdit");
var folderTypeConversionUtil_1 = require("./folderTypeConversionUtil");
var getActionClauseTypeOptions_1 = require("./getActionClauseTypeOptions");
var getConditionalExceptionClauseTypeOptions_1 = require("./getConditionalExceptionClauseTypeOptions");
var mapPeopleIdentityToReadWriteRecipientWellViewState_1 = require("./mapPeopleIdentityToReadWriteRecipientWellViewState");
var setSelectedFolderId_1 = require("./setSelectedFolderId");
var store_1 = require("../../store/store");
var addNewClause_1 = require("../addNewClause");
var legacy_1 = require("satcheljs/lib/legacy");
var KB_TO_B = 1024;
/**
 * Maps an inbox rule's properties to inbox rule clauses to populated the edit page
 * @param inboxRule the rule whose properties will be added to the edit store
 */
exports.default = legacy_1.action('mapInboxRuleToInboxRuleClauses')(legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesEditState; },
})(function mapInboxRuleToInboxRuleClauses(inboxRule, state) {
    // map conditional clauses
    var optionState = state.optionState;
    var clauseSection;
    var conditionalExceptionClauseTypes = getConditionalExceptionClauseTypeOptions_1.default();
    var actionClauseTypes = getActionClauseTypeOptions_1.default();
    optionState.ruleName = inboxRule.Name;
    optionState.ruleId = inboxRule.Identity ? inboxRule.Identity.RawIdentity : null;
    optionState.ignoreSubsequentRules = inboxRule.StopProcessingRules;
    clauseSection = 'conditional';
    for (var _i = 0, conditionalExceptionClauseTypes_1 = conditionalExceptionClauseTypes; _i < conditionalExceptionClauseTypes_1.length; _i++) {
        var conditionalClause = conditionalExceptionClauseTypes_1[_i];
        var clauseValueToAdd = void 0;
        switch (conditionalClause) {
            case 'from':
                if (inboxRule.From) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.From);
                }
                break;
            case 'to':
                if (inboxRule.SentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.SentTo);
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.MyNameInToOrCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.SentOnlyToMe) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.MyNameInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.MyNameInCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.MyNameNotInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.SubjectContainsWords) {
                    clauseValueToAdd = inboxRule.SubjectContainsWords.slice(0);
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.SubjectOrBodyContainsWords) {
                    clauseValueToAdd = inboxRule.SubjectOrBodyContainsWords.slice(0);
                }
                break;
            case 'inTheBody':
                if (inboxRule.BodyContainsWords) {
                    clauseValueToAdd = inboxRule.BodyContainsWords.slice(0);
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.FromAddressContainsWords) {
                    clauseValueToAdd = inboxRule.FromAddressContainsWords.slice(0);
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.RecipientAddressContainsWords) {
                    clauseValueToAdd = inboxRule.RecipientAddressContainsWords.slice(0);
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.HeaderContainsWords) {
                    clauseValueToAdd = inboxRule.HeaderContainsWords.slice(0);
                }
                break;
            case 'withImportance':
                if (inboxRule.WithImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.WithImportance;
                }
                break;
            case 'sensitivity':
                if (inboxRule.WithSensitivity !== 'NullSensitivity') {
                    clauseValueToAdd = inboxRule.WithSensitivity;
                }
                break;
            case 'flag':
                if (inboxRule.RequestedAction !== 'NullInboxRuleMessageFlag') {
                    clauseValueToAdd = inboxRule.RequestedAction;
                }
                break;
            case 'type':
                if (inboxRule.MessageTypeMatches != 'NullInboxRuleMessageType') {
                    clauseValueToAdd = inboxRule.MessageTypeMatches;
                }
                break;
            case 'attachment':
                if (inboxRule.HasAttachment) {
                    clauseValueToAdd = inboxRule.HasAttachment;
                }
                break;
            case 'atLeast':
                if (inboxRule.WithinSizeRangeMinimum) {
                    clauseValueToAdd = inboxRule.WithinSizeRangeMinimum / KB_TO_B;
                }
                break;
            case 'atMost':
                if (inboxRule.WithinSizeRangeMaximum) {
                    clauseValueToAdd = inboxRule.WithinSizeRangeMaximum / KB_TO_B;
                }
                else if (inboxRule.WithinSizeRangeMinimum) {
                    // If user has minimum value but didn't input an at most value, set at most value to maximum (999,999 kb)
                    clauseValueToAdd = 999999;
                }
                break;
            case 'before':
                if (inboxRule.ReceivedBeforeDate) {
                    clauseValueToAdd = inboxRule.ReceivedBeforeDate;
                }
                break;
            case 'after':
                if (inboxRule.ReceivedAfterDate) {
                    clauseValueToAdd = inboxRule.ReceivedAfterDate;
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, conditionalClause, clauseValueToAdd);
        }
    }
    clauseSection = 'action';
    for (var _a = 0, actionClauseTypes_1 = actionClauseTypes; _a < actionClauseTypes_1.length; _a++) {
        var actionClause = actionClauseTypes_1[_a];
        var clauseValueToAdd = void 0;
        switch (actionClause) {
            case 'moveTo':
                if (inboxRule.MoveToFolder) {
                    var ruleFolderId = inboxRule.MoveToFolder.RawIdentity;
                    // check if the inbox rule folder id is a raw identity or folder ID
                    var ruleFolder = ruleFolderId.indexOf(':\\') > -1
                        ? folderTypeConversionUtil_1.getFolderFromRawId(ruleFolderId)
                        : folderTypeConversionUtil_1.getFolderFromFolderId(ruleFolderId);
                    if (ruleFolder) {
                        setSelectedFolderId_1.default(ruleFolder.folderId);
                    }
                    clauseValueToAdd = ruleFolder;
                }
                break;
            case 'copyTo':
                if (inboxRule.CopyToFolder) {
                    var ruleFolderId = inboxRule.CopyToFolder.RawIdentity;
                    // check if the inbox rule folder id is a raw identity or folder ID
                    var ruleFolder = ruleFolderId.indexOf(':\\') > -1
                        ? folderTypeConversionUtil_1.getFolderFromRawId(ruleFolderId)
                        : folderTypeConversionUtil_1.getFolderFromFolderId(ruleFolderId);
                    if (ruleFolder) {
                        setSelectedFolderId_1.default(ruleFolder.folderId);
                    }
                    clauseValueToAdd = ruleFolder;
                }
                break;
            case 'delete':
                if (inboxRule.DeleteMessage) {
                    clauseValueToAdd = inboxRule.DeleteMessage;
                }
                break;
            case 'pin':
                if (inboxRule.PinMessage) {
                    clauseValueToAdd = inboxRule.PinMessage;
                }
                break;
            case 'read':
                if (inboxRule.MarkAsRead) {
                    clauseValueToAdd = inboxRule.MarkAsRead;
                }
                break;
            case 'markImportance':
                if (inboxRule.MarkImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.MarkImportance;
                }
                break;
            case 'forwardTo':
                if (inboxRule.ForwardTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ForwardTo);
                }
                break;
            case 'forwardAsAttachmentTo':
                if (inboxRule.ForwardAsAttachmentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ForwardAsAttachmentTo);
                }
                break;
            case 'redirectTo':
                if (inboxRule.RedirectTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.RedirectTo);
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, actionClause, clauseValueToAdd);
        }
    }
    clauseSection = 'exception';
    for (var _b = 0, conditionalExceptionClauseTypes_2 = conditionalExceptionClauseTypes; _b < conditionalExceptionClauseTypes_2.length; _b++) {
        var exceptionClause = conditionalExceptionClauseTypes_2[_b];
        var clauseValueToAdd = void 0;
        switch (exceptionClause) {
            case 'from':
                if (inboxRule.ExceptIfFrom) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ExceptIfFrom);
                }
                break;
            case 'to':
                if (inboxRule.ExceptIfSentTo) {
                    clauseValueToAdd = mapPeopleIdentityToReadWriteRecipientWellViewState_1.default(inboxRule.ExceptIfSentTo);
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.ExceptIfMyNameInToOrCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.ExceptIfSentOnlyToMe) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.ExceptIfMyNameInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.ExceptIfMyNameInCcBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.ExceptIfMyNameNotInToBox) {
                    clauseValueToAdd = true;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.ExceptIfSubjectContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfSubjectContainsWords.slice(0);
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.ExceptIfSubjectOrBodyContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfSubjectOrBodyContainsWords.slice(0);
                }
                break;
            case 'inTheBody':
                if (inboxRule.ExceptIfBodyContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfBodyContainsWords.slice(0);
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.ExceptIfFromAddressContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfFromAddressContainsWords.slice(0);
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.ExceptIfRecipientAddressContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfRecipientAddressContainsWords.slice(0);
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.ExceptIfHeaderContainsWords) {
                    clauseValueToAdd = inboxRule.ExceptIfHeaderContainsWords.slice(0);
                }
                break;
            case 'withImportance':
                if (inboxRule.ExceptIfWithImportance !== 'NullImportance') {
                    clauseValueToAdd = inboxRule.ExceptIfWithImportance;
                }
                break;
            case 'sensitivity':
                if (inboxRule.ExceptIfWithSensitivity !== 'NullSensitivity') {
                    clauseValueToAdd = inboxRule.ExceptIfWithSensitivity;
                }
                break;
            case 'flag':
                if (inboxRule.ExceptIfFlaggedForAction !== 'NullInboxRuleMessageFlag') {
                    clauseValueToAdd = inboxRule.ExceptIfFlaggedForAction;
                }
                break;
            case 'type':
                if (inboxRule.ExceptIfMessageTypeMatches !== 'NullInboxRuleMessageType') {
                    clauseValueToAdd = inboxRule.ExceptIfMessageTypeMatches;
                }
                break;
            case 'attachment':
                if (inboxRule.ExceptIfHasAttachment) {
                    clauseValueToAdd = inboxRule.ExceptIfHasAttachment;
                }
                break;
            case 'atLeast':
                if (inboxRule.ExceptIfWithinSizeRangeMinimum) {
                    clauseValueToAdd = inboxRule.ExceptIfWithinSizeRangeMinimum;
                }
                break;
            case 'atMost':
                if (inboxRule.ExceptIfWithinSizeRangeMaximum) {
                    clauseValueToAdd = inboxRule.ExceptIfWithinSizeRangeMaximum;
                }
                break;
            case 'before':
                if (inboxRule.ExceptIfReceivedBeforeDate) {
                    clauseValueToAdd = inboxRule.ExceptIfReceivedBeforeDate;
                }
                break;
            case 'after':
                if (inboxRule.ExceptIfReceivedAfterDate) {
                    clauseValueToAdd = inboxRule.ExceptIfReceivedAfterDate;
                }
                break;
        }
        // only add clauses to the edit page that have corresponding values on the inbox rule
        if (clauseValueToAdd) {
            addNewClause_1.default(clauseSection, exceptionClause, clauseValueToAdd);
        }
    }
    initializeInboxRuleEdit_1.default();
    return;
}));
//# sourceMappingURL=mapInboxRuleToInboxRuleClauses.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/mapInboxRuleToInboxRuleClauses.js
// module id = 3384
// module chunks = 2 90